// First and last, everywhere. Four copies of this had drifted into three
// different answers, so a member could see one avatar in the app, another in
// the extension and a third on a community post.
export function initialsFrom(name, fallback = "") {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0];
    if (!first)
        return fallback;
    if (parts.length === 1)
        return ([...first][0] ?? "").toUpperCase();
    const last = parts.at(-1) ?? "";
    return `${[...first][0] ?? ""}${[...last][0] ?? ""}`.toUpperCase();
}
//# sourceMappingURL=initials.js.map